module.exports = __webpack_public_path__ + "media/assets/images/tour/2_Tour_1-6cda6a20f25cce516dc3e2bc8e146937.png";